var map = {
	"./about-img.svg": 392,
	"./headset.svg": 195,
	"./main-logo.svg": 393,
	"./premium.svg": 394,
	"./proffessional.svg": 395,
	"./shap-01.svg": 396,
	"./shap-02.svg": 397,
	"./starter.svg": 398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 391;